import { ImageWraper } from '@components/shared/wraper/ImageWraper'

type Props = {
  description: string
  iconPath: string
}

export const ResolveProblemListItem = ({
  description,
  iconPath,
}: Props): JSX.Element => {
  return (
    <div className="flex flex-row items-start">
      <div className="pt-[1vw] lg:pt-[.5vw] w-[4.3vw] lg:w-[1.3vw]">
        <ImageWraper
          src={iconPath}
          width={20}
          height={20}
          alt="解決イメージアイコン"
        />
      </div>
      <div className="ml-[3.7vw] lg:ml-[1.1vw] w-[66.9vw] lg:w-[54.7vw] text-[3.7vw] lg:text-[1.3vw] leading-[6.4vw] lg:leading-[2.2vw] text-[#000000]">
        {description}
      </div>
    </div>
  )
}
